import React from "react";
import styled from "styled-components";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import TableAbout from "../components/TableAbout"
import { useNavigate } from "react-router-dom";
import heatmap_img from "../assets/heatmap.webp"
import colourmap_img from "../assets/colourmap.webp";
import { Helmet } from "react-helmet";
import { useFetchInfoQuery } from "../store/apis/api";

export default function About () {
    const navigate = useNavigate();
    const links = [
        { name: "Home", link: "/landing" , isActive: false},        
        { name: "Upload new images", link: "/upload", isActive:false },
        { name: "View analysis", link: "/resultsHighLevel", isActive:false },
        { name: "About", link: "/about", isActive: true},
        { name: "Help", link: "/help", isActive: false}
        // { name: "Contact us", link: "/contactUs", isActive:false },
    ];

    const { data } = useFetchInfoQuery(); 

    return (
        <Container>
            <Helmet>
                <title>About | SolarAIDD </title>
                <meta name="description" content="Learn how CSIR developed SolarAIDD to solve solar reliability challenges. Our AI models are trained on thousands of EL images for industry-leading accuracy."/>
                <meta name="keywords" content="CSIR solar research, renewable energy AI, PV module reliability, solar technology innovation South Africa" />
                <meta name="robots" content="index, follow" />
                <link rel="canonical" href="https://solaraidd.csir.co.za/about" />
            </Helmet>
            <Navbar links={links} isScrolled={true}/>
            <div className="container">
                <div className="title">
                    <h1> About SolarAIDD </h1>
                    <div className="sub-title">
                        <h4> Welcome to the Solar Analysis and Inspection for Defects system! Here you can find more information on how SolarAIDD works, what it looks for,
                            and what analysis and reports it generated on your EL images.  </h4>                    
                </div>

                <div className="description">
                    <h2> How does SolarAIDD work? </h2>
                    <h4> SolarAIDD allows you to upload a batch of EL images and uses modern AI techniques to analyse the state of the PV modules. </h4>

                        <h3> High level overview of the analysis for batches of EL images </h3>
                        <div className="box">
                        <h4> On the View Analysis page, a summary of the analysis for your batches can be seen. From this page, you can navigate 
                            to the Batch analysis page by clicking on a batch in the table, or on the batch heat map. From the Batch Analysis page,
                            you can view the Module analysis by clicking on one of the colour images representing the defects and PV features 
                            detected. </h4>
                        </div>

                        <h3> Analysis for a batch </h3>
                        <div className="box">
                        <h4> The table shows the statistical anlysis for the batch. Next to it, a heat map is displayed. The heatmap represents
                            the cell or half-cell dimensions of the PV modules in the batch, i.e., the heat map has the same number of rows and 
                            columns as the PV modules. The key to the right of the heat map shows the number of PV modules in the batch. The image below
                            shows the number of PV modules that has a defect in the same cell location. For example, in the heat map shown below, 
                            there are 10 PV modules in the batch with 12 rows and 6 columns. 5 of the 10 PV modules have a defective
                            cell in the row 2 and column 6. This analysis is useful to identify trends in the location of defects in the PV modules. </h4>
                        <img src={heatmap_img} alt={"heat_map"} />
                        </div>

                        <h3> Analysis for a module </h3>
                        <div className="box">
                        <h4> SolarAIDD creates a colour image of the EL image where different colours represent different defects and PV features 
                            that are typically found in the EL images. These colour images are called colour maps. SolarAIDD analyses these defects and PV features and generates tabular reports for 
                            PV cells and modules.  </h4>
                        </div>
                        <img src={colourmap_img} style={{"width":"80%"}} alt={"colour_map"} />
                    </div>

                </div>

                <div className="info">
                    <h2> What does SolarAIDD look for? </h2>
                    <h4> SolarAIDD uses modern AI techniques to find defects in PV modules. It also looks for PV features that are typically
                        found in the EL images of PV modules. The tables below give a summary of the defects and PV features the SolarAIDD system can find.
                    </h4>
                </div>            
                <TableAbout title={"PV Defects"} data={data?.defects} colours={data?.defectsColours} textColours={data?.defectsText} />
                <TableAbout title={"PV Features"} data={data?.pv} colours={data?.pvColours} textColours={data?.pvText} />           
                <Footer/> 
            </div>
            
        </Container>
    )
}

const Container = styled.div`
background: white;
.container {
    position: absolute;
    top: 7rem;
    left: 0;
    width: 100vw;
    color: black;
    background: white;
    display: flex;  
    flex-direction: column;
    align-items: center;
    gap: 2rem;
    h4 {
        font-weight: normal;
    }
    .title {
        text-align: center;  
        display: flex;  
        flex-direction: column;
        align-items: center;      
        .sub-title {      
            width: 70vw;     
            padding: 2rem 0rem;
            text-align: center;
        }
    }
    .description {
        display: flex;  
        flex-direction: column;
        align-items: left;
        width: 80vw;
        text-align: center;
        gap: 2rem;  
        .box  {
            width: 80vw;
            display: flex;  
            flex-direction: column;
            align-items: center;            
            text-align: left;
            gap: 1rem;            
            img {
                width: 80%;
                height: 100%;
                object-fit: cover;
            } 
        }
    }
    .info {
        width: 80vw;
        text-align: center;
        display: flex;  
        flex-direction: column;
        align-items: center;
        gap: 2rem;   
    }
    .video-box {
        text-align: center;
        width: 90vw;
        display: flex;  
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        .subtitle {            
            padding: 0.5rem;
        }
        Video {
            max-width: 100%;
            max-height: 100%;
        }
    }
    .disclaimers {        
        width: 85vw;
        display: flex;  
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        gap: 1rem;
        padding: 2rem;
        .subtitle {            
            padding: 0.5rem 0rem;
            text-align: center;
        }
        .info-box {
            width: 85vw;
            display: flex;  
            flex-direction: column;
            align-items: center;
            justify-content: space-between;
            text-align: center;
            padding: 0.5rem;
        }
    }
}
`